import { useEffect, useState } from 'react';
import { fetchData } from './Helpers'; 

export default function Fields() {
  const [ddIndex, setDdIndex] = useState(0);
  const [fields, setFields] = useState([]);
  const [fieldsData, setFieldsData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData("Ownership_Field_Descriptions").then(res => {
      setFieldsData(res);
      setFields([...new Set(res.map(item => item["endpoints"]))]);
      setLoading(false);
    });
  }, []);
  
  return (
    <div className='main-div'>
      <ef-loader class="loader" hidden={!loading}></ef-loader>
      <h4>FIELD DESCRIPTIONS</h4>
      <p>Understanding details provided in Ownership & Insiders by API End-points</p>
      <ef-layout className="est-fields-package-layout">
        {fields.map((value, index) => (
          <ef-layout>
            <ef-layout className="est-fields-inner-layout" onClick={() => setDdIndex(ddIndex === index+1 ? 0 : index+1)} key={value}>
              <ef-panel spacing>
                {ddIndex !== index+1 && <ef-icon icon="right"></ef-icon>}
                {ddIndex === index+1 && <ef-icon icon="down"></ef-icon>}
                <span>{value}</span>
              </ef-panel>
            </ef-layout>
            {ddIndex === index+1 && <ef-layout className="est-endpoint-layout">
              <table>
                <thead>
                  <tr>
                    <th>Field</th>
                    <th>Definition</th>
                  </tr>
                </thead>
                <tbody>
                  {fieldsData.filter(item => item["endpoints"] === value).map((item, idx) => (
                    <tr key={idx}>
                      <td>{item["field"]}</td>
                      <td>{item["definition"]}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </ef-layout>}
          </ef-layout>
        ))}
      </ef-layout>
    </div>
  );
}